import { Component } from 'opus-angular-seed-core';
import template from './template.html';


@Component({
    bindings: {
        list: '='
    },
    template
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/paginationv2/tools/totalItems/index.js